import {Vue, VueVendor} from 'ui.vue'; // Vue == BX.Vue (обёртка) и VueVendor == просто Vue
import App from './App.vue';

import 'libs/util/polyfills';


const createApp = (params) => {
  /// В Битриксе BX.Vue.create вместо new Vue
  return Vue.create({
    // return new VueVendor({
    el: params.el,
    data: params,
    render: h => h(App)
  });
};

export {createApp as init};

